import * as Sentry from "@sentry/react";
import { runtimeEnv } from "@/lib/runtimeEnv";

export function initSentry() {
  const dsn = runtimeEnv.sentryDsn();
  if (!dsn) return;

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: runtimeEnv.sentryTracesSampleRate(),
    sendDefaultPii: false,
    // Financial screens are never session-recorded. A DSN cannot override this.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    environment: runtimeEnv.environment(),
  });
}
